<template>
  <introduce-page>
    <div style="width: 100%;">
      <div v-for="(detail, i) in dataList" :key="i" style="width: 100%;margin-bottom: 20px;">
        <el-row style="width: 100%;height: 90px;display: flex;justify-content: center;align-items: center;">
          <div style="height: 80px;width: 80px;border-radius: 50px;border: 1px solid gray;">
            <el-image :src="getImageUrl(detail.avatar)" style="height: 100%;width: 100%;border-radius: 50px;"></el-image>
          </div>
          <div style="width: 80px;text-align: left;margin-left: 20px;font-weight: bold;font-size: 18px">{{detail.name}}</div>
        </el-row>
        <div style="width: 100%;margin-top: 10px;">
          <div style="line-height: 30px;white-space: pre-wrap;text-align: justify;text-indent: 2em;">{{detail.content}}</div>
        </div>
      </div>
    </div>
  </introduce-page>
</template>

<script>
import axios from 'axios'
import IntroducePage from './IntroducePage'
export default {
  name: 'CoreTeam',
  components: {IntroducePage},
  data() {
    return {
      dataList: [
        {avatar: 'bf1d2d8e8d9146eb8f81dfb018de2053', name: '张文魁', 'content': '公司创始人CEO,华中科技大学电气工程专业博士，武昌理工学院副教授，拥有20多年能源行业从业经验，先后在中国华电、中国科学院软件所、中船重工709研究所、中国电子武汉中原电子从事发电、智慧城市、智慧园区、配电自动化及智慧能源等领域的生产和研发工作，担任技术总监。获得湖北省科技进步奖1项、中国电子科技进步1项、中国电子科技人才奖1项，获得授权专利10多项，其中发明专利5项。'},
        {avatar: '10ed442bcfd747e1b790e422dc4af4a3', name: '刘沛', 'content': '公司首席顾问，华中科技大学教授，博士生导师。电力系统继电保护知名专家，中国水力发电工程学会水电自动化与计算机控制工程专委会委员，中国电机工程学会分专业委员会委员。多次获得省部级科技进步奖，主持过国家自然科学基金项目4项，培养博士10多名，硕士几十名。'},
        // {avatar: 'acf453b606f249f4a5bd2b336dcafa2b', name: '王晨', 'content': '联合创始人，比利时根特大学数据分析与数学建模系工学博士、西北工业大学数学与统计学院理学博士，从事大数据分析、人工智能领域研究，主持过多项国家及省基金，在国际权威期刊发表SCI论文10多篇，负责公司大数据分析、人工智能算法研究。'},
        {avatar: '95a22da3eb1d4c15a585bee704de0703', name: '崔晓彦', 'content': '联合创始人，武汉理工大学艺术专业博士，国内著名漫画家、插画师，从事工业及美术设计领域研究，受邀在武汉琴台大剧院、丰子恺画院、武汉大学万林艺术博物馆等举办画展，漫画作品——《平安顺遂、遇难成祥》、《平平安安》被国家博物馆收藏，负责公司产品工艺设计及UI设计。'},
        // {avatar: '7ed6736d41c0490aae8b46ea25a32dbf', name: '汤鹏飞', 'content': '联合创始人，西北工业大学数学与统计学院理学学士，拥有大型国企多年研发经验，精通Java、C++、MATLAB、Python、大数据分析等，主持过智慧园区、综合能源服务平台等多个大型项目开发。现担任公司研发经理。'}
        {avatar: '50759f9f2198497f8199b04de6847beb', name: '张宏超', 'content': '联合创始人，湖北大学微电子硕士。担任营销总监，在大型国企和软件公司从事多年研发管理和产品经理工作，有多年智慧城市、智慧能源领域工作经验。'},
        {avatar: '50759f9f2198497f8199b04de6847beb', name: '洪满', 'content': '联合创始人，哈尔滨工业大学计算机专业学士。担任研发经理，拥有大型游戏公司和国企多年研发经验，精通Java、C++、MATLAB、Python、大数据分析等，主持过智慧路灯、配电自动化、智慧园区、综合能源服务平台等多个大型项目。'}
      ]
    }
  },
  created() {
    document.documentElement.scrollTop = 0
  },
  methods: {
    getImageUrl(id) {
      return '/myApi/coreTeam/getImageById?id=' + id
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/introduce/CoreTeam.vue